// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let MarkupHelpers = require("../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function LoginLayout$Component(props) {
  return JsxRuntime.jsx(MarkupHelpers.Container.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: props.children,
          className: "relative w-full pb-[30px] sm:pb-0 sm:h-[380px]"
        }),
        className: "col-span-12 sm:col-span-8 sm:col-start-3 lg:col-span-6 lg:col-start-4"
      }),
      className: "grid grid-cols-12 gap-4"
    })
  });
}

let Component = {
  make: LoginLayout$Component
};

function asLayout(page) {
  return JsxRuntime.jsx(LoginLayout$Component, {
    children: page
  });
}

exports.Component = Component;
exports.asLayout = asLayout;
/* MarkupHelpers Not a pure module */
